import type { BrandsFilters } from '@app/pages/Warehouses/Brands/types';

export const PF = 'brands';

export const initialFilters: BrandsFilters = {
  Page: 1,
  ItemsPerPage: 20,
  SearchTerm: '',
};
